/* src/features/5DD/SleepModal.js */
import React, { useState, useEffect } from 'react';

const ratingLabels = ['Horrible', 'Poor', 'Okay', 'Good', 'Great'];

const sleepTags = [
  'Easy Sleep',
  'Kept Waking Up',
  "Couldn't Sleep",
  "Woke up/Couldn't Return",
  'Hard to Wake',
];

const styles = {
  overlay: {
    position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.85)', zIndex: 1000,
    display: 'flex', justifyContent: 'center', alignItems: 'center',
  },
  container: {
    background: 'rgba(0, 0, 0, 0.5)', padding: '25px', borderRadius: '8px',
    maxWidth: '420px', width: '90%', textAlign: 'center', color: '#fff',
    boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
  },
  title: { margin: '0 0 18px 0', fontSize: '1.3em', color: '#fff' },
  label: {
    margin: '0 0 8px 0', fontWeight: 'bold', fontSize: '0.95em',
    textAlign: 'left', color: '#fff', borderBottom: '1px solid #555',
    paddingBottom: '5px',
  },
  ratingRow: {
    display: 'flex', justifyContent: 'center', gap: '8px', marginBottom: '20px',
  },
  ratingBtn: {
    width: '52px', height: '52px', borderRadius: '6px', border: '1px solid #ccc',
    background: '#f0f0f0', color: '#333', cursor: 'pointer',
    display: 'flex', flexDirection: 'column',
    alignItems: 'center', justifyContent: 'center', fontSize: '1.1em', fontWeight: 'bold',
    transition: 'all 0.15s',
  },
  ratingBtnSelected: {
    border: '1px solid #4caf50', background: 'rgba(76, 175, 80, 0.2)',
    color: '#e8f5e9',
  },
  ratingLabel: { fontSize: '0.55em', fontWeight: 'normal', marginTop: '2px' },
  tagsGrid: {
    display: 'flex', flexWrap: 'wrap', gap: '8px', justifyContent: 'center',
    marginBottom: '20px',
  },
  tagBtn: {
    padding: '8px 14px', borderRadius: '20px', border: '1px solid #555',
    background: 'rgba(255, 255, 255, 0.1)', color: '#fff', cursor: 'pointer',
    fontSize: '0.9em', transition: 'all 0.15s',
  },
  tagBtnSelected: {
    border: '1px solid #4caf50', background: 'rgba(76, 175, 80, 0.2)',
    color: '#e8f5e9', fontWeight: 'bold',
  },
  buttons: { display: 'flex', gap: '10px', justifyContent: 'center', marginTop: '10px' },
  btnCancel: {
    padding: '10px 20px', backgroundColor: '#555', color: '#fff',
    border: '1px solid #555', borderRadius: '4px', cursor: 'pointer',
  },
  btnConfirm: {
    padding: '10px 20px', background: 'rgba(76, 175, 80, 0.2)', color: '#e8f5e9',
    border: '1px solid #4caf50', borderRadius: '4px', cursor: 'pointer', fontWeight: 'bold',
  },
  btnConfirmDisabled: {
    padding: '10px 20px', backgroundColor: '#555', color: '#aaa',
    border: '1px solid #555', borderRadius: '4px', cursor: 'not-allowed',
    opacity: 0.5,
  },
};

function SleepModal({ isOpen, onClose, onConfirm, initialRating, initialTags }) {
  const [rating, setRating] = useState(null);
  const [selectedTags, setSelectedTags] = useState([]);

  useEffect(() => {
    if (isOpen) {
      setRating(initialRating || null);
      setSelectedTags(initialTags || []);
    }
  }, [isOpen, initialRating, initialTags]);

  if (!isOpen) return null;

  const toggleTag = (tag) => {
    setSelectedTags((prev) =>
      prev.includes(tag) ? prev.filter((t) => t !== tag) : [...prev, tag]
    );
  };

  const handleConfirm = () => {
    if (rating) onConfirm(rating, selectedTags);
  };

  return (
    <div style={styles.overlay}>
      <div style={styles.container}>
        <h3 style={styles.title}>Log Sleep</h3>

        <p style={styles.label}>Sleep Quality</p>
        <div style={styles.ratingRow}>
          {ratingLabels.map((label, i) => {
            const value = i + 1;
            const isSelected = rating === value;
            return (
              <button
                key={value}
                style={{ ...styles.ratingBtn, ...(isSelected ? styles.ratingBtnSelected : {}) }}
                onClick={() => setRating(value)}
              >
                {value}
                <span style={styles.ratingLabel}>{label}</span>
              </button>
            );
          })}
        </div>

        <p style={styles.label}>Status</p>
        <div style={styles.tagsGrid}>
          {sleepTags.map((tag) => {
            const isSelected = selectedTags.includes(tag);
            return (
              <button
                key={tag}
                style={{ ...styles.tagBtn, ...(isSelected ? styles.tagBtnSelected : {}) }}
                onClick={() => toggleTag(tag)}
              >
                {tag}
              </button>
            );
          })}
        </div>

        <div style={styles.buttons}>
          <button style={styles.btnCancel} onClick={onClose}>Cancel</button>
          <button
            style={rating ? styles.btnConfirm : styles.btnConfirmDisabled}
            onClick={handleConfirm}
            disabled={!rating}
          >
            Log Sleep
          </button>
        </div>
      </div>
    </div>
  );
}

export default SleepModal;
